export default "__VITE_ASSET__B4odEb6o__"